import styled from 'styled-components';

const PageContainer = styled.div`
`;

export const HomePage = () => {
  return (
	<PageContainer />
  );
};

export default HomePage;
